/**
 * Transforms S3 request paths by stripping trailing slashes
 *
 * This helps avoid routing issues with S3-compatible endpoints.
 *
 * @param path - The original request path
 * @returns The path with trailing slash removed (preserves query string)
 *
 * @example
 * transformS3Path('/api/apps/ID/blob/storage/')
 * // Returns: '/api/apps/ID/blob/storage'
 *
 * @example
 * transformS3Path('/api/apps/ID/blob/storage/?list-type=2')
 * // Returns: '/api/apps/ID/blob/storage?list-type=2'
 *
 * @example
 * transformS3Path('/api/apps/ID/blob/storage')
 * // Returns: '/api/apps/ID/blob/storage' (no change)
 */
export function transformS3Path(path: string): string {
  // Split path and query string (only on first ?)
  const questionMarkIndex = path.indexOf('?');

  if (questionMarkIndex === -1) {
    // No query string - just strip trailing slash from path
    return path.endsWith('/') ? path.slice(0, -1) : path;
  }

  // Has query string - strip trailing slash before the ?
  const pathPart = path.substring(0, questionMarkIndex);
  const queryPart = path.substring(questionMarkIndex); // includes the ?

  const cleanedPath = pathPart.endsWith('/') ? pathPart.slice(0, -1) : pathPart;
  return cleanedPath + queryPart;
}
